var _Path, _Path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgQuickStart(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M10.5 18.868c2.227 0 4.32-.867 5.893-2.44a8.286 8.286 0 002.44-5.893c0-4.594-3.737-8.334-8.333-8.334-2.227 0-4.32.868-5.893 2.44a8.281 8.281 0 00-2.44 5.894c0 4.594 3.737 8.333 8.333 8.333zM5.188 5.222a7.461 7.461 0 015.312-2.2c4.143 0 7.513 3.37 7.513 7.513a7.461 7.461 0 01-2.2 5.312 7.462 7.462 0 01-5.313 2.2c-4.143 0-7.513-3.369-7.513-7.512 0-2.008.781-3.893 2.2-5.313z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M8.292 14.256a.413.413 0 00.419-.015l5.252-3.362a.413.413 0 00.19-.347c0-.14-.07-.27-.19-.346L8.709 6.829a.412.412 0 00-.416-.015.415.415 0 00-.214.359v6.724c0 .15.08.289.214.36zm.606-6.333l4.081 2.612-4.08 2.612V7.923z"
  })));
}
export default SvgQuickStart;